module.exports = __webpack_public_path__ + "img/fushimi-HP-pattern003.617e5206.png";